<script>
import { mapActions } from 'vuex';

/**
 * マニフェスト検索キーワード編集モーダル
 */
export default {
  name: 'EditManifestSearchKeywordDialog',
  components: {},
  mixins: [],
  props: {
    manifestId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      openDialog: false,
      forms: {
        keyword: null,
      }
    }
  },
  computed: {},
  watch: {
    /**
     * モーダル表示制御フラグの監視
     * ・validationの初期化
     * ・form情報の初期化
     * ・編集データの取得
     * @param val { Boolean } 変更後の値
     */
    openDialog(val) {
      this.$nextTick(() => this.$refs.observer.reset());
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (val) {
        this.setVariable();
      }
    }
  },
  created() {},
  methods: {
    ...mapActions('DriverManifestManagementManifestSearchKeyword', {
      fetchManifestSearchKeyword: 'edit',
      updateManifestSearchKeyword: 'update',
    }),
    closeButtonClickEvent () {
      this.openDialog = false
    },
    /**
     * 更新ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.observer.validate().then((result) => {
        if(result) {
          this.register();
        }
      })
    },
    /**
     * 編集データの取得
     */
    setVariable () {
      this.fetchManifestSearchKeyword({manifest_id: this.manifestId,}).then((content) => {
        this.forms.keyword = content.keyword;
      })
    },
    register () {
      this.updateManifestSearchKeyword({ manifest_id: this.manifestId, params: { keyword: this.forms.keyword } }).then(() => {
        this.$emit('registerCallback');
        this.openDialog = false;
      })
    }
  },
}
</script>

<template>
  <v-dialog
    v-model="openDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"

  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        small
      >
        <v-icon small>
          mdi-pencil
        </v-icon>
        &nbsp;編集
      </v-btn>
    </template>
    <validation-observer ref="observer">
      <v-card
        flat
      >
        <v-toolbar flat>
          <v-toolbar-title>マニフェスト検索キーワードの編集</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                name="マニフェスト検索キーワード"
                rules="max:25"
              >
                <v-text-field
                  v-model="forms.keyword"
                  :error-messages="errors"
                  clearable
                  dense
                  hide-details="auto"
                  label="マニフェスト検索キーワード"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>マニフェスト検索キーワード</span>
                    <span class="ml-1">
                      ({{ forms.keyword?.length || 0 }} / 25)
                    </span>
                    <span class="red--text font-weight-bold">&emsp;※&nbsp;DXEStation排出モードにも表示されます。&nbsp;</span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            更新
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>
